import e from "react";
import { componentName as r } from "../../../utils/bem/index.js";
function t(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {},
      n = Object.keys(t);
    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    }))), n.forEach(function (r) {
      var n;
      n = t[r], r in e ? Object.defineProperty(e, r, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = n;
    });
  }
  return e;
}
function n(n) {
  var a = n.fw,
    o = n.name,
    i = void 0 === o ? "" : o,
    l = n.solid,
    c = void 0 !== l && l,
    f = n.light,
    s = void 0 !== f && f,
    u = n.regular,
    b = void 0 !== u && u,
    p = n.thin,
    d = void 0 !== p && p,
    m = n.duotone,
    v = void 0 !== m && m,
    y = n.sharp,
    O = void 0 !== y && y,
    g = n.brands,
    h = void 0 !== g && g,
    j = n.clickable,
    w = n.className,
    P = function (e, r) {
      if (null == e) return {};
      var t,
        n,
        a = function (e, r) {
          if (null == e) return {};
          var t,
            n,
            a = {},
            o = Object.keys(e);
          for (n = 0; n < o.length; n++) t = o[n], r.indexOf(t) >= 0 || (a[t] = e[t]);
          return a;
        }(e, r);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++) t = o[n], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
      }
      return a;
    }(n, ["fw", "name", "solid", "light", "regular", "thin", "duotone", "sharp", "brands", "clickable", "className"]),
    N = null == i ? void 0 : i.replace(/^(fa-)/, "");
  switch (N) {
    case "file-icon-visio":
    case "file-icon-sh":
    case "file-icon-ps1":
      return e.createElement("i", t({
        className: N
      }, P));
  }
  var k = r("icon", w, !c && !s && !b && !d && !v && !O && !h && "fa", O && !c && !s && !b && !d && !v && "fa-sharp", h && !c && !s && !b && !d && !v && "fab", !1 !== c && (O ? "fass" : "fas"), !1 !== s && "fal", !1 !== b && (O ? "fasr" : "far"), !1 !== d && "fat", !1 !== v && "fad", a && "fa-fw", j && "cursor-pointer", "fa-" + N);
  return e.createElement("i", t({
    className: k
  }, P));
}
n.displayName = "Icon";
export { n as Icon };